import React from "react";
import "./reference.css" 
export function TicTacEpigrafe({ epigraph, parafh }) {
  return (
    <>
      <hgroup>
        <h4>{epigraph}</h4>
        <br />
      </hgroup>
      <p>{parafh}</p>
      <br />
    </>
  );
}
export function TicTacSubtitulos({ subtitle, epigraph, parafh }) {
  return (
    <>
      <hgroup>
        <h3>{subtitle}</h3>
        <br />
        <h4>{epigraph}</h4>
      </hgroup>
      <p>{parafh}</p>
      <br />
    </>
  );
}
export function TicTacBody({ tictac, under }){
  return(
    <>
      {tictac.map((e,index) =>(
        <div key={index}>
          <h4>{e}</h4>
          <p>{under[index]}</p>
          <br />
        </div>
      ))}
    </>
  )
}


export function TicTacParafh({ parafh }) {
  return <p>{parafh}</p>;
}
export function TicTacParafh1( props ) {
  return (
    <>
      {props.parafh.map((e, index) => (
        <p key={index}>{e}</p>
      ))}
      <br />
    </>
  );
}


export function TicTacView({ capture }) {
  return <img className="__div_TicTac2" src={capture} alt="" role="img"/>;
}
export function TicTacView1( props ) {
  return (
    <>
      {props.capture.map((e, index) => (
        <img key={index} className="__div_TicTac2" src={e} alt="" role="img"/>
      ))}
      <br />
    </>
  );
}
export function TicTacListas( props ) {
  return (
    <>
      <section>
        {props.list.map((element, index) => (
          <div key={index}>
            <p>{element}</p>
          </div>
        ))}
        <br />
      </section>
    </>
  );
}
export function TicTacTable({ tabla, cuerpo }) {
  return(
    <>
      <section>
        <div>
          <br />
            <table className="container_table">
                <thead>
                    <tr>
                      {tabla.map( (e , index) => (
                        <th  key={index}>{ e }</th>
                      ) ) }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                      {cuerpo.map( (e , index) => (
                        <td  key={index}>{ e }</td>
                      ) ) }
                    </tr>
                </tbody>
            </table> 
          <br />           
        </div>
        <br />
      </section>    
    </>
  )
}
export function TicTacCode ({ code }) {
  return(
    <>
      <p id="left">
        {code.map( (e ,index) => (
          <code key={index} >
              {e}
              <br />
          </code>
        ))}
        <br /> 
      </p>
    </>
  )
}


export function TictacDivFlex( props ) {
  return (
    <>
      <div className="div_TicTac">
        <img  src={props.capture} alt="" role="img"/>
        <p>{props.parafh}</p>
      </div>
    </>
  );
}
export function TictacDivRight( props ) {
  return (
    <>
      <div className="div_TicTac">
        <p>{props.parafh}</p>
        <img src={props.capture} alt="" role="img"/>
      </div>
    </>
  );
}
export function TictacDivBlock1( props ) {
  return (
    <>
      {props.parafh.map((element, index) => (
        <div key={index}>
          <img className="__div_TicTac2" src={props.capture} alt="" role="img"/>
          <br />
          <p> {element}</p>
          <br />
        </div>
      ))}
    </>
  );
}
export function TictacDivBlock( props ) {
  return (
    <>
      <div>
        <img className="__div_TicTac2" src={props.capture} alt="" role="img"/>
        <br />
        <p>{props.parafh}</p>
        <br />
      </div>
    </>
  );
}


export function TicTacEncabezado({ title, subtitle, epigraph, parafh }) {
  return (
    <>
      <h2 id="nodo_in">{title}</h2>
      <br />
      <h3>{subtitle}</h3>
      <br />
      <p>{parafh}</p>
      <br />
      <h4>{epigraph}</h4>
      <br />
    </>
  );
}
export function TicTacEncabezado2({ title, subtitle, parafh }) {
  return (
    <>
      <h2 id="nodo_in">{title}</h2>
      <br />
      <h3>{subtitle}</h3>
      <br />
      <p>{parafh}</p>
      <br />
    </>
  );
}
export function TicTacEncabezado3({ title, subtitle, epigraph }) {
  return (
    <>
      <h2 id="nodo_in">{title}</h2>
      <br />
      <h3>{subtitle}</h3>
      <br />
      <h4>{epigraph}</h4>
      <br />
    </>
  );
}
